<template>
  <div class="container">
    <div class="logobox">
      <img class="bigImg" :src="require('img/menu/logoText.png')" />
    </div>
    <div class="payBox">
      <div class="content">
        <PayBox :orderId="orderId" mode="client" />
      </div>
    </div>
    <div class="footer">
      版权信息 闽ICP备13015634号-7 ©2024 Foxit Software Incorporated. All rights
      reserved.
    </div>
  </div>
</template>

<script>
import PayBox from "cpnts/web/PayBox/PayBox.vue";

export default {
  data() {
    return {
      orderId: null,
      error: false
    };
  },
  components: {
    PayBox
  },
  created() {
    const { orderId } = this.$route.query;
    this.orderId = orderId;
  }
};
</script>

<style lang="scss" scoped>
.container {
  background-color: rgb(248, 248, 248);
  min-height: 860px;
  height: 100%;
  position: relative;
}
.logobox {
  height: 90px;
  width: 100%;
  position: relative;
  .bigImg {
    position: absolute;
    width: 114px;
    top: 29px;
    left: 27px;
  }
}

.payBox {
  width: 100%;
  min-height: 600px;
  min-width: 1000px;
  width: 100%;
  .content {
    margin: 0 auto;
    justify-content: center;
    display: flex;
  }
}

.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  min-width: 1000px;
  height: 80px;
  background-color: #47485b;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #c4c4cb;
}
</style>
